export const iconFontAwesomeArrowsArrowsSplitUpAndLeft = (
	<i className="fa-solid fa-arrows-split-up-and-left"></i>
);
